import { CreateKeyValueRequest } from "@models/base/createKeyValueRequest.model";

export class CreateCalendarioJudicialRequest extends CreateKeyValueRequest{
  fecha?: Date;
  esHabil!: boolean;
  esFeriado!: boolean;
  esFeriaJudicial!: boolean;
  motivo!: string;
  idJurisdiccion?: number;
  idFuero?: number;
  idJuzgado?: number;
  horarioDesde?: string; // Formato recomendado: "HH:mm"
  horarioHasta?: string;
}
